class AtModal {
    constructor ($element, data, eventkey) {
        /**
         * Assign the clicked element
         */
        this._$element = $element;

        /**
         * Save the html data object
         */
        this._data = data ? data : '';

        /**
         * Check and save the module external configuration
         */
        this._externalConfig = window.At.Modal.config ? window.At.Modal.config : {};

        /**
         * Create a unique id for the modal
         * used the timestamp
         * @type {number}
         * @private
         */
        this._modal_id = Date.now();

        /**
         * Combine default config with the element data object, attach the unique modal id
         */
        this._config = $.extend(true, {}, AtModal.defaults, this._externalConfig, this._data, {modal_id: this._modal_id});

        /**
         * Assign the body tag
         */
        this._$body = $('body');

        /**
         * If already available in the DOM, assign the modal as this._$modal
         * @type {any}
         * @private
         */
        this._$modal = this._config.modal ? $(this._config.modal) : $(`#${this._config.class.modal}-${this._config.modal_id}`);

        /**
         * Store eventkey
         */
        this._eventkey = eventkey;

        /**
         * Lodash templates for the modal, backdrop overlay and close button
         * @type {{modal: Function, closeButton: Function, backdrop: Function}}
         */
        this.template = {
            modal: this._config.template_modal ? _.template($(this._config.template_modal).html()) : _.template(this._config.template.modal),
            closeButton: _.template(this._config.template.close_button),
            backdrop: _.template(this._config.template.backdrop)
        };

        /**
         * Check if there is an cookie set
         * if config cookie key is presented => close function immediately
         */
        if ((this._config.cookie && window.At.Util.Cookie.Get(this._config.cookie.key) !== undefined)) {
            return false;
        }

        /**
         * Bind click (namespace) click event to element
         */
        if (this._eventkey !== 'load') {
            this._$element.on('click.AtModal', this._provider.bind(this));
        } else {
            this._provider();
        }
    }

    /**
     * If the user clicked, this guy knows what to do
     * @private
     */
    _provider (event) {

        /**
         * Set a new querystring in the url,
         * Check if history pushstate is available
         */
        if (history.pushState && this._$element.is('[href]')) {
            const newUrl = `${window.location.protocol}//${window.location.host}${window.location.pathname}${this._$element.attr('href')}`;

            window.history.pushState({path:newUrl}, '', newUrl);
        }

        /**
         * But first remove the focus detach the element click event
         */
        this._$element
            .blur()
            .off('click.AtModal');

        /**
         * Call inject function
         */
        this._inject();

        /**
         * Prevent reloading page
         */
        if (event) {
            event.preventDefault();
        }
    }

    /**
    * The DOM needs extra html. the config mode value decides what html is coming to the DOM
    * @returns {boolean}
    * @private
    */
    _inject () {

        /**
         * Check for config mode, if unavailable im not going to give you some html sugar sweets
         */
        if (this._config.mode === undefined) {
            return false;
        }

        /**
         * Do you have for me the config mode? here you get some html sugar for you DOM sir
         */
        if (this._config.mode === 'create') {
            this._$body
                .append(this.template.modal({data: this._config}))
                .append(this.template.backdrop({data: this._config}));

            if (!this._config.locked) {
                if (this._config.position.close === 'outside') {
                    this._$body
                        .find(`#${this._config.class.modal}-${this._config.modal_id}`)
                        .append(this.template.closeButton({data: this._config}));

                } else if (this._config.position.close === 'inside') {
                    this._$body
                        .find(`#${this._config.class.modal}-${this._config.modal_id}`)
                        .children(`.${this._config.class.modal_block}`)
                        .append(this.template.closeButton({data: this._config}));
                }
            }
        } else if (this._config.mode === 'open') {
            this._$modal.after(this.template.backdrop({data: this._config}));

            if (!this._config.locked) {
                if (this._config.position.close === 'outside') {
                    this._$modal.append(this.template.closeButton({data: this._config}));

                } else if (this._config.position.close === 'inside') {
                    this._$modal
                        .children(`.${this._config.class.modal_block}`)
                        .append(this.template.closeButton({data: this._config}));
                }
            }
        }

        /**
         * Check if there is alternative styling available in the config, this is an object
         * if available set the value as attr style
         */
        if (Object.keys(this._config.style).length > 0 && typeof this._config.style === 'object') {
            $(this._$modal)
                .children(`.${this._config.class.modal_block}`)
                .css(this._config.style);
        }

        /**
         * I'm okay, next level, open that thing
         */
        this._open();
    }

    /**
     * Open the injected or given modal
     * @private
     */
    _open () {
        /**
         * Trigger event hook
         */
        this._$modal.trigger('AtModal:onOpen');

        /**
         * I'm sorry, what was the modal again?
         * @type {any}
         * @private
         */
        this._$modal = this._config.modal ? $(this._config.modal) : $(`#${this._config.class.modal}-${this._config.modal_id}`);

        /**
        * Founded it, here it is in full effect
        */
        this._$modal.addClass(this._config.class.active);

        /**
        * Disable body scrolling with utility class
        */
        this._$body.addClass(this._config.class.disable_scrolling);

        /**
        * I'm very okay now, next level, attach beautiful events (need some scoll now)
        */
        this._events();
    }

    /**
     * Get rid of the modal, close that thing
     * @private
     */
    _close () {
        /**
         * Trigger event hook
         */
        this._$modal.trigger('AtModal:onClose');

        /**
         * Modal founded, im not stoppid, remove that active class
         */
        this._$modal
            .removeClass(this._config.class.active)
            .one('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', () => {
                /**
                 * I'w waiting over here, ohhh beautiful effect, what ur finished... okay, next level than
                 * Modify the modal
                 */
                this._remove();
            });

        /**
         * Enable body scrolling by removing utility class
         */
        this._$body.removeClass(this._config.class.disable_scrolling);

        /**
         * Check if there is an cookie config available
         * if available set cookie, with config values, or default values
         */
        if ((this._config.cookie && window.At.Util.Cookie.Get(this._config.cookie.key) === undefined)) {
            /**
             * Set variables for weektime and store a default cookie value
             * @type {number}
             */
            const weekInMs = 1000 * 60 * 60 * 24 * 7;
            const cookieValue = this._config.cookie.value ? this._config.cookie.value : true;

            /**
             * Set cookies default values
             * @type {{path: string, expires: Date}}
             */
            window.At.Util.Cookie.Defaults = {
                path: '/',
                expires: new Date(new Date().getTime() + weekInMs)
            };

            /**
             * Create cookie
             */
            window.At.Util.Cookie.Set(this._config.cookie.key, cookieValue, {
                expires: this._config.cookie.expires
            });
        }
    }

    /**
    * Destroy it from the DOM, make the DOM a beautiful cleaned room, again *** (i know, yes u did) **
    * @private
    */
    _remove () {
        /**
         * Because my master needed a two way master script, i have to check again if this is an injected
         * modal or an peace of beautifull html
         * [1] first remove the backdrop, then the modal its self... yes this is well tested my dear
         * [2] cleanup the html modal by removing the backdrop and beautiful close button
         */
        if (this._config.mode !== 'open') {
            this._$modal // [1]
                .next(`.${this._config.class.backdrop}`)
                .remove()
                .end()
                .remove();
        } else {
            this._$modal  // [2]
                .next(`.${this._config.class.backdrop}`)
                .remove()
                .end()
                .find(`.${this._config.class.close}`)
                .remove();
        }

        /**
         * Remove hidden button if eventkey = load
         */
        if (this._eventkey === 'load') {
            this._$element.remove();
        }

        /**
         * Okay where almost done now, detached those beautiful custom events
         */
        this._unbindEvents();
    }

    /**
    * Attach all the events used in this script
    * @private
    */
    _events () {
        /**
         * We make the body a whole click area, attach an event now
         */
        this._$body.on('AtModal:Close', () => {
            this._close();
        });

        /**
         * Nice event, but how i trigger it, yess i see.
         * Only if i click not on the modal its self... genius man
         */
        this._$body.on('click.AtModal:Close', event => {
            const $target = $(event.target);

            if (this._config.locked) {
                return; // not allowed to close modal by click
            }

            if (
                ($target.hasClass(this._config.class.modal) && $target.hasClass(this._config.class.active)) ||
                $target.hasClass(this._config.class.close) || ($target[0].hasAttribute(this._config.attr.close)) ||
                ($(event.target).parents(`.${this._config.class.close}`).length)
            ) {
                /**
                 * Okay i survived, close that ting
                 */
                this._$body.trigger('AtModal:Close');
            }
        });

        /**
         * Close modal if escape key is pressed
         */
        this._$body.on('keydown.AtModal:Close', event => {
            if (event.keyCode == 27 && !this._config.locked) {
                /**
                 * Trigger close event
                 */
                this._$body.trigger('AtModal:Close');
            }
        });

        /**
         * Okay, this is pretty far now, attach the origin click event to element
         */
        if (this._eventkey !== 'load') {
            this._$element.on('click.AtModal', this._provider.bind(this));
        }
    }

    /**
     * Destroy the events :(
     * (if this step is not taken, i get twins all over the DOM)
     * @private
     */
    _unbindEvents () {
        /**
         * Pow Pow Pow
         */
        this._$body
            .off('AtModal:Close')
            .off('click.AtModal:Close')
            .off('keydown.AtModal:Close');

        /**
         * Disable checking if the css3 tranisition is ended,
         * especially for html modals (they doesn't remove from the dom)
         */
        this._$modal.off('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend');
    }

    /**
     * Attach new modal
     * @private
     */
    _attach () {
        const $element = $(this.selector || this);
        const data = $element.data('at-modal');

        new AtModal($element, data, (data.event || 'click'));
    }
}

/**
 * Default configuration object
 * @type {{mode: string, class: {modal: string, active: string, body: string, backdrop: string, close: string}, attr: {close: string}, content: {header: string, image: string, body: string}, log: {info: string, attention: string, red: string}}}
 */
AtModal.defaults = {
    mode: 'create',
    class: {
        modal: 'at-modal',
        modifier: '',
        type: '',
        modal_block: 'at-modal-block',
        active: 'is--active',
        body: 'is--at-modal-open',
        backdrop: 'at-modal-backdrop',
        close: 'at-modal-close',
        disable_scrolling: 'disable-scrolling'
    },
    attr: {
        close: 'data-disclosure-close'
    },
    position: {
        close: 'inside'
    },
    style: {},
    content: {
        header: '',
        image: '',
        body: ''
    },
    template_modal: null,
    template: {
        modal: '<div class="<%= data.class.modal %><% if (data.class.type) { %> <%= data.class.type %><% } %>" id="<%= data.class.modal %>-<%= data.modal_id %>">' +
        '<div class="at-modal-block <%= data.class.modifier %>">' +
        '<figure class="at-modal-image">' +
        '<img src="<%= data.content.image %>" />' +
        '</figure>' +
        '<div class="at-modal-content">' +
        '<% if (data.content.header) { %><h1><%= data.content.header %></h1><% } %>' +
        '<%= data.content.body %>' +
        '</div>' +
        '</div>' +
        '</div>',
        close_button: '<button class="<%= data.class.close %>" <%= data.attr.close %>="">Sluiten</button>',
        backdrop: '<div class="<%= data.class.backdrop %>"></div>'
    },
    locked: false,
    log: {
        info: 'color: #7f7f7f;',
        attention: 'color: #2d7ac6;',
        red: 'color: #ff0000;'
    },
    cookies: null
};

export default AtModal;
